import React, { useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dateTimeToView } from "../../../../utils/date.utils";
import { routeName } from "../../../../routes/routeName";
import { icons } from "../../../../assets/icons/icons";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../../utils/statusRequest";
import { useTranslation } from "react-i18next";

interface ListAdvisorConsultRequestProps {
  data: any;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalItems: number;
  sortBy: string;
  sortType: string;
  pageLimit: number;
  setPageLimit: React.Dispatch<React.SetStateAction<number>>;
  advisorId: number;
}

const ListConsultationRequest: React.FC<ListAdvisorConsultRequestProps> = ({
  data,
  page,
  setPage,
  totalItems,
  sortBy,
  sortType,
  pageLimit,
  setPageLimit,
  advisorId,
}) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const { profile } = useSelector((state: any) => state.profile);

  const headCells = [
    {
      id: "fullname",
      width: 50,
      disablePadding: true,
      align: "start",
      label: t("ชื่อ - นามสกุล"),
    },
    {
      id: "student_nickname",
      disablePadding: true,
      width: 15,
      align: "start",
      label: t("ฉายา"),
    },
    {
      id: "student_no",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("รหัสประจำตัวนักศึกษา"),
    },
    {
      id: "consultation_name",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("เรื่องที่ขอคำปรึกษา"),
    },
    {
      id: "consultation_group",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("ประเภทขอคำปรึกษา"),
    },
    {
      id: "date_request",
      disablePadding: false,
      align: "center",
      width: 20,
      label: t("วันที่ขอคำปรึกษา"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 20,
      label: t("สถานะ"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_student,
      student_frist_name,
      student_last_name,
      student_nickname,
      student_no,
      consultation_name,
      date_request,
      status,
      advisor_student_detaill,
      created_date,
      faculty_name,
      grade_level
    } = objData;

    let parsedAdvisorStudentDetail = [];

    try {
      parsedAdvisorStudentDetail = JSON.parse(advisor_student_detaill);
    } catch (error) {
      console.error("Error parsing advisor_student_detaill:", error);
    }

    const objRenderData = {
      key: id_advisor_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: student_frist_name + " " + student_last_name,
        },
        {
          option: "TEXT",
          align: "start",
          label: student_nickname,
        },
        {
          option: "TEXT",
          align: "center",
          label: student_no,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.advisor_type_name ?? "",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.advisor_group ?? "",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : "",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status
              )}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.manageAdvisors +
                      `/consultation-detail/${id_advisor_student}?advisor_id=${advisorId}&grade_level=${grade_level}&faculty_name=${faculty_name}`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <section className="w-full mt-10">
      <TableCustom
        tableMinWidth={2000}
        tableFixedWidth
        customScroll
        page={page}
        pageLimit={pageLimit}
        sortBy={sortBy}
        sortType={sortType}
        headCells={headCells}
        rowCount={totalItems}
        rowsData={
          data &&
          data.map((data: any, i: any) => {
            return renderData(data, i);
          })
        }
        onSort={() => {}}
        setPageLimit={(value: number) => setPageLimit(value)}
        setPage={(value: number) => setPage(value)}
      />
    </section>
  );
};

export default ListConsultationRequest;
